import { STATUS } from "../../../constants/constants";

/**
 * Converts Case Ids into Comma Seperate String 
 * @param {*} data 
 */
export const getFormattedCaseIds = (data) => {
    let caseIdsArr = data.split(' \n');
    if (caseIdsArr[caseIdsArr.length - 1] === "") {
        caseIdsArr.splice(-1, 1);
    }
    return caseIdsArr.join();
}

/**
 * Converts Master Data in dropdown format [ {label:'', value:''}]
 * @param {*} dataArr 
 */
export const getFormattedMasterData = (dataArr = []) => {
    let result = dataArr.map(obj => {
        let newObj = {}
        newObj.label = obj.masterDataValue;
        newObj.value = obj.masterDataId;
        return newObj;
    });
    return result;
}

/**
 * Converts loggedUserDetail Data into case manager ids dropdown format
 * @param {*} loggedUserDetail 
 */
export const getFormattedCaseManagerList = (loggedUserDetail = {}) => {
    let label = `${loggedUserDetail.firstName} ${loggedUserDetail.lastName}`;
    let value = loggedUserDetail.userClientId;
    return [{ label, value }];
}


/**
 * This function returns the Dropdown Object 
 */
export const getDropdownSelectedFormat = (key, result) => {
    let obj = null;
    if (result[key]) {
        obj = { label: `${result[key].masterDataValue}`, value: result[key + 'Id'] }
    }
    return obj;
}

export const getCMDropdownSelectedFormat = (dataObj = {}) => {
    let obj = null
    if (dataObj && Object.keys(dataObj).length > 0) {
        return { label: `${dataObj.firstName} ${dataObj.lastName}`, value: dataObj.systemId }
    }
    return obj;
}

export const getExplanationListByStatus = (explanationList, statusId) => {
    return explanationList.map(obj => {
        obj.disabled = (STATUS.DUPLICATE === statusId && obj.label !== 'True Duplicate') || (obj.label === 'True Duplicate' && ![STATUS.LINKED, STATUS.DUPLICATE].includes(statusId));
        return obj;
    });
}

export const formatKeywords = (keywords) => {
    return keywords ? keywords.replace(/\s*,\s*/g, ",").split(',').join('\n') : "";
}

export const formatDateFieldsArrayToString = (dateFieldsArr) => {
    let arr = dateFieldsArr.map(str => {
        if (str === 'dateAbstractReviewed') return 'Date Record Reviewed';
        if (str === 'dateFlwUpReceived') return 'Date Follow-up Received';
        // adding space between strings
        const result = str.replace(/([A-Z])/g, ' $1');

        // converting first character to uppercase and join it to the final string
        const final = result.charAt(0).toUpperCase() + result.slice(1);
        return final;
    });

    return arr.join(', ');
}

export const parseString = (str) => {
    if (str === null) {
        return null;
    } else {
        return str ? str : "";
    }
}

